module.exports = __webpack_public_path__ + "img/C.8caa0d61.svg";